import { Controller } from "@hotwired/stimulus";

// Character counter controller for meta description field
export default class extends Controller {
  static targets = ["counter", "warning"];
  static values = { max: Number };

  connect() {
    this.updateCounter();
  }

  // Update counter on input
  input() {
    this.updateCounter();
  }

  updateCounter() {
    const currentLength = this.element.value.length;
    const maxLength = this.maxValue || 155;

    // Update counter display
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${currentLength}/${maxLength}`;

      // Change color based on length
      if (currentLength > maxLength) {
        this.counterTarget.classList.remove("text-gray-400", "text-yellow-500");
        this.counterTarget.classList.add("text-red-500");
      } else if (currentLength > maxLength * 0.9) {
        this.counterTarget.classList.remove("text-gray-400", "text-red-500");
        this.counterTarget.classList.add("text-yellow-500");
      } else {
        this.counterTarget.classList.remove("text-red-500", "text-yellow-500");
        this.counterTarget.classList.add("text-gray-400");
      }
    }

    // Show/hide warning
    if (this.hasWarningTarget) {
      if (currentLength > maxLength) {
        this.warningTarget.classList.remove("hidden");
      } else {
        this.warningTarget.classList.add("hidden");
      }
    }
  }
}
